import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  Output,
  QueryList,
} from '@angular/core';
import { SupportClass } from '@lib/components/support-class';
import { Subscription } from 'rxjs';
import { MyBookingTabsItemComponent } from './my-booking-tabs-item.component';

/**
 * [BaseUI] tab
 * タブコンポーネント
 *
 * 動的に追加する場合updateTab()をコールすること
 *
 * @param id HTMLに設定するID
 * @param activeNum 有効なtabの番号
 * 使い方　asw-tab-itemをmetaに記載する
 * <asw-tab #tabListComponent >
 *     <asw-tab-item title="タブ1">
 *         <ssn-sample-page-child1 #tabComponent1></ssn-sample-page-child1>
 *     </asw-tab-item>
 *     <asw-tab-item title="タブ2">
 *         <ssn-sample-page-child2></ssn-sample-page-child2>
 *     </asw-tab-item>
 *     <asw-tab-item title="タブ3" [disable]="tuikaTabDisable">
 *         <ssn-sample-page-child2></ssn-sample-page-child2>
 *     </asw-tab-item>
 * </asw-tab>
 *
 *
 */
@Component({
  selector: 'asw-my-booking-tabs',
  templateUrl: './my-booking-tabs.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyBookingTabsComponent extends SupportClass implements AfterContentInit {
  _subscription: Subscription = new Subscription();
  constructor(private _changeDetector: ChangeDetectorRef) {
    super();
  }

  @Input() activeNum!: string;

  @Output()
  selectEvent = new EventEmitter<string>();

  destroy() {}

  @ContentChildren(MyBookingTabsItemComponent) tabs!: QueryList<MyBookingTabsItemComponent>;

  public tabComponentList: Array<{
    title: string;
    src: string;
    srcActive: string;
    component: any;
    index: string;
  }> = [];

  @Input()
  public id: string = this.constructor.name;

  ngAfterContentInit(): void {
    this.updateTab();
  }

  public updateTab() {
    this.tabComponentList = this.tabs
      .toArray()
      .filter((data) => data.disable === false)
      .map((data) => {
        return {
          title: data.title,
          component: data.content,
          src: data.src,
          srcActive: data.srcActive,
          index: data.index,
        };
      });
    this._changeDetector.markForCheck();
  }

  tabClick(index: string) {
    this.selectEvent.emit(index);
  }
}
